// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navItem-module--wrapper--1SaaF","wrapperMobileOnly":"navItem-module--wrapper-mobile-only--oUqOm"};